import React from "react"
import PropTypes from "prop-types"
import Chip from "@material-ui/core/Chip"
import { withTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"

const DisturbanceListItem = props => {
  return (
    <>
      <div className="d-flex">
        <div
          className="align-self-center overflow-hidden me-auto"
        >
          <div>
            <h5 className="font-size-14 text-truncate mb-1">
              <a
                href={"/disturbance-notice/" + props.item.guid}
                target="_blank"
                rel="noreferrer"
              >
                {props.t(props.item.title)}
              </a>
            </h5>
            <p className="text-muted mb-1">{props.item.date}</p>

            <Chip
              size="small"
              key={props.item.id + "_chip"}
              className="font-size-11 me-2 my-2"
              style={{
                background: props.item.color,
                color: "white",
              }}
              label={props.t(props.item.status)}
            />

            {props.item.targets.map(target => (
              <Chip
                size="small"
                key={target + "_chip"}
                className="font-size-11 me-2 my-2"
                label={props.t(target)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

DisturbanceListItem.propTypes = {
  t: PropTypes.any,
  item: PropTypes.any,
}

export default withRouter(withTranslation()(DisturbanceListItem))
